// @ts-nocheck

/**
 * * `emerging` - emerging
 * `developing` - developing
 * `established` - established
 */
export type ReaderProfileDataPrintAwarenessEnum =
  typeof ReaderProfileDataPrintAwarenessEnum[keyof typeof ReaderProfileDataPrintAwarenessEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReaderProfileDataPrintAwarenessEnum = {
  emerging: "emerging",
  developing: "developing",
  established: "established",
} as const;
